import { useState, useEffect } from "react";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ClearIcon from '@mui/icons-material/Clear';

const RegionFilter = () => {
    const [regions, setRegions] = useState<any[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<string>("");

    useEffect(() => {
        // Get regions from user profile
        const userProfile = sessionStorage.getItem('user-profile');
        if (userProfile) {
            const user = JSON.parse(userProfile);
            if (user.regions && Array.isArray(user.regions)) {
                setRegions(user.regions);
            }
        }

        // Load saved region filter
        const savedRegion = sessionStorage.getItem('global-region-filter');
        if (savedRegion) {
            setSelectedRegion(savedRegion);
        }
    }, []);

    const handleRegionChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        setSelectedRegion(value);
        
        if (value) {
            sessionStorage.setItem('global-region-filter', value);
        } else {
            sessionStorage.removeItem('global-region-filter');
        }
        
        // Reload the page to apply the filter
        window.location.reload();
    };

    const handleClearFilter = () => {
        setSelectedRegion("");
        sessionStorage.removeItem('global-region-filter');
        
        // Reload the page to clear the filter
        window.location.reload();
    };

    // Don't render if user has no regions
    if (regions.length === 0) {
        return null;
    }

    return (
        <Box sx={{ px: 2, py: 2 }}>
            <FormControl fullWidth size="small">
                <InputLabel id="region-filter-label">Filter by Region</InputLabel>
                <Select
                    labelId="region-filter-label"
                    id="region-filter"
                    value={selectedRegion}
                    label="Filter by Region"
                    onChange={handleRegionChange}
                    sx={{ backgroundColor: 'white' }}
                >
                    <MenuItem value="">
                        <em>All Regions</em>
                    </MenuItem>
                    {regions.map((region) => (
                        <MenuItem key={region.region_id} value={region.region_id}>
                            {region.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {selectedRegion && (
                <Button
                    fullWidth
                    size="small"
                    startIcon={<ClearIcon />}
                    onClick={handleClearFilter}
                    sx={{ mt: 1, textTransform: 'none' }}
                    variant="outlined"
                    color="secondary"
                >
                    Clear Filter
                </Button>
            )}
        </Box>
    );
};

export default RegionFilter;
